'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, forwardRef, isValidElement } from 'react';
import { cn } from '../../utils/cn';
const AccordionIcon = forwardRef(({ children, asChild, className, ...otherProps }, ref) => {
    if (asChild && isValidElement(children)) {
        return cloneElement(children, {
            itemRef: ref,
            ...otherProps,
        });
    }
    return (_jsx("span", { ...otherProps, className: cn(className), ref: ref, children: children ?? (_jsxs("svg", { className: "shrink-0 fill-metal-600 dark:fill-metal-300", width: "16", height: "16", xmlns: "http://www.w3.org/2000/svg", children: [_jsx("rect", { y: "7", width: "16", height: "2", rx: "1", className: `origin-center transform transition duration-150 ease-out` }), _jsx("rect", { y: "7", width: "16", height: "2", rx: "1", className: `origin-center rotate-90 transform transition duration-150 ease-out` })] })) }));
});
AccordionIcon.displayName = 'AccordionIcon';
export { AccordionIcon };
